import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box } from '@mui/material';

export const CreateGroupModal = ({ showadd, handleCloseAdd, lngsltd, group, setGroup, groupNameError, handleSave }) => {
    return (
        <Dialog open={showadd} onClose={handleCloseAdd} sx={{
            '& .MuiDialog-paper': {
                width: '20%', // Custom width as a percentage of the screen
                maxWidth: 'none', // Override the maxWidth setting if you want to control width manually
            },
        }}>
            <DialogTitle sx={{ backgroundColor: '#efedf0' }}>
                {lngsltd["Add Group"]}
            </DialogTitle>
            <DialogContent>
                <Box component="form">
                    <TextField
                        fullWidth
                        label={
                            <span>
                                {lngsltd["Group Name"]}
                                <span style={{ color: 'red' }}>*</span>
                            </span>
                        }
                        variant="outlined"
                        placeholder={lngsltd["Enter Group Name"]}
                        value={group}
                        onChange={(e) => setGroup(e.target.value)}
                        error={!!groupNameError}
                        helperText={groupNameError}
                        margin="normal"
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={handleSave}>
                    {lngsltd["Create"]}
                </Button>
                <Button variant="outlined" color="error" onClick={handleCloseAdd}>
                    {lngsltd["Cancel"]}
                </Button>
            </DialogActions>
        </Dialog>
    )
}